import * as React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentTab } from '../../selectors/tabs';
import { ETabs } from '../../types/redux/tabs';
import { setSearchTextAgencies, setSearchTextRealtors } from '../../actions/filters';

/**
 * Хук возвращает нужный экшн установки текста в поиск в зав-ти от текущего выбранного таба
 * */
export const useSetSearchTextHandler = () => {
  const currentTab = useSelector(getCurrentTab);

  return React.useMemo(() => {
    const isRealtorsListing = currentTab === ETabs.Realtors;

    return isRealtorsListing ? setSearchTextRealtors : setSearchTextAgencies;
  }, [currentTab]);
};
